<template>
    <div class="post-container">
      <div class="match-width">
        <title-bar :mini="this.mini" class="title-bar"></title-bar>
      </div>
      <post-media class="post-media"></post-media>
    </div>
</template>

<script>
import TitleBar from './title-bar.vue';
import PostMedia from './post-media.vue';

export default {
  name: "ModalPost",
  components: {
    TitleBar,
    PostMedia,
  },
  props: {
    mini: {type: Boolean, default: false}
  },
  data: () => ({}),
};
</script>

<style scoped>
.post-container {
  background-color: transparent;
  border-radius: 5px;
  display: table;
  margin: 0 auto;
}
.title-bar {
  margin-top: 10px;
}
.post-media {
  max-width: 900px;
}
.match-width {
    display: flex;
}
.match-width div {
  flex-grow: 1;
  width: 0;
}
</style>